module.exports = __webpack_public_path__ + "img/footer_sbdc_logo.bb668c17.png";